/* Vegan Chocolate Co — Macro Mike layer behaviour, 20 October 2026.
   Slideshow, rail arrows, videos that play only while on screen, and the
   sticky add-to-cart bar. Everything degrades to a usable page without JS. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Hero slideshow: crossfade, dots, autoplay that pauses on hover/focus. */
  document.querySelectorAll('[data-mm-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-mm-slide]');
    var dots = root.querySelectorAll('[data-mm-dot]');
    if (slides.length < 2) return;
    var index = 0;
    var timer = null;
    var delay = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', String(!on));
        s.querySelectorAll('a').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
    function start() { if (!reduceMotion && !timer) timer = setInterval(function () { show(index + 1); }, delay); }
    function stop() { clearInterval(timer); timer = null; }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { stop(); show(i); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { stop(); show(index + (dx < 0 ? 1 : -1)); start(); }
      x0 = null;
    });
    show(0);
    start();
  });

  /* Rail arrows scroll one card at a time. */
  document.querySelectorAll('[data-mm-rail-nav]').forEach(function (nav) {
    var rail = document.getElementById(nav.getAttribute('data-mm-rail-nav'));
    if (!rail) return;
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dir]');
      if (!btn) return;
      var card = rail.firstElementChild;
      var step = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
      rail.scrollBy({ left: step * (btn.getAttribute('data-dir') === 'next' ? 1 : -1), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  });

  /* Muted looping videos play only while visible (saves data on phones). */
  var vids = document.querySelectorAll('video[data-mm-autoplay]');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting && !reduceMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.35 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  /* Sticky add-to-cart: shows once the main button scrolls out of view. */
  var sticky = document.querySelector('[data-mm-sticky]');
  var mainBtn = document.querySelector('.pdp__atc');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', off);
      sticky.setAttribute('aria-hidden', String(!off));
    }).observe(mainBtn);
    var stickyBtn = sticky.querySelector('[data-mm-sticky-add]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () { mainBtn.click(); });
  }
})();
